export default __webpack_public_path__ + "static/media/bg.b717a7a4.png";